import React, { useState, useRef, useMemo } from 'react'
import { Group } from '@/model/types/goods'

import './goods-group.scss'
import { getBEMCls } from '@/utils/classname'
import { Popover } from 'antd'
import { showLayer } from '@/utils/layer'
import DropContent from './drop-content'
import { observer } from 'mobx-react'
import { get } from '@/utils'
import SecondItemGroup from './second-group-item'
import EditGroup, { DeleteGroup } from './edit-group'
import { TYPE } from '../../goods-library'

interface GroupItemProps {
    group: Group
    groupArr: Group[]
    groupIndex: number
    secondGroupId: number
    handleDrop: (goods_ids: number[], groupId: number, second?: number) => void
    [key: string]: any
    onClick?: (v: Group[], groupIndex: number) => void
}

const GroupItem: React.FC<GroupItemProps> = observer(props => {
    const { group } = props
    const [popoverVisable, setPopoverVisable] = useState<boolean>(false)
    const popoverRef = useRef<HTMLDivElement>(null)
    const getCls = (e?: string, m?: string) => getBEMCls('goods-group', e, m)

    const hidePopover = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation()
        setPopoverVisable(false)
    }

    const isActive = useMemo(
        () =>
            group.id === props.goodsLibraryStore.groupId ||
            (!!group.secondary_group.length &&
                get(group, 'secondary_group[0].id', 0) &&
                group.secondary_group.every(i => i.id === props.goodsLibraryStore.secondGroupId)),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [group, props.goodsLibraryStore.groupId, props.goodsLibraryStore.secondGroupId],
    )

    const isAllGroup = useMemo(() => !!group.secondary_group.length && !group.secondary_group[0].id, [group])

    const selectNum = useMemo(() => {
        const r = props.goodsLibraryStore.selectGroupNum[group.id + '']
        if (r) {
            if (typeof r === 'number') {
                return r
            } else {
                return Object.keys(r).reduce<number>((pre, next) => pre + r[next], 0)
            }
        } else {
            return 0
        }
    }, [group.id, props.goodsLibraryStore.selectGroupNum])

    return (
        <>
            <div
                className={`${
                    isActive
                        ? get(group, 'secondary_group[0].id', 0)
                            ? getCls('item', 'active-second')
                            : getCls('item', 'active')
                        : getCls('item')
                }`}
                onClick={() => {
                    props.onClick && props.onClick(props.groupArr, props.groupIndex)
                    // 有二级分组或者是全部商品分组
                    if (!props.group.secondary_group.length || get(props.group, 'secondary_group[0].id') === 0) {
                        props.goodsLibraryStore.setActiveGroupId(group.id)
                        props.goodsLibraryStore.setActiveSecondGroupId(0) // 初始化一下,防止在无二级分组的情况下请求二级分组
                    }
                }}
            >
                {!!selectNum && <div className={getCls('badge')}>{selectNum}</div>}

                {group.is_default && <div className={getCls('default')}>默认</div>}
                {!!group.secondary_group.length && !!group.secondary_group[0].id && (
                    <i
                        className={`icon6xiala2-20 iconfont ${getCls('arrow')}`}
                        style={{
                            transform: group.open ? 'rotate(0)' : 'rotate(-90deg)',
                        }}
                    />
                )}
                {group.name}
                <div ref={popoverRef} data-margin-left-6>
                    <Popover
                        visible={popoverVisable}
                        getPopupContainer={() => popoverRef.current as HTMLDivElement}
                        onVisibleChange={() => setPopoverVisable(!popoverVisable)}
                        trigger="click"
                        placement="bottomRight"
                        content={
                            <>
                                {!isAllGroup && (
                                    <div
                                        className={`${getCls('list-item')}`}
                                        onClick={e => {
                                            hidePopover(e)
                                            showLayer(<EditGroup name={props.group.name} groupId={props.group.id} />)
                                        }}
                                    >
                                        编辑
                                    </div>
                                )}
                                <div
                                    className={`${getCls('list-item')}`}
                                    onClick={e => {
                                        hidePopover(e)
                                        showLayer(
                                            <EditGroup groupId={isAllGroup ? void 0 : props.group.id} mode="add" />,
                                        )
                                    }}
                                >
                                    {isAllGroup ? '添加一级分组' : '添加子分组'}
                                </div>
                                {!props.group.is_default && !isAllGroup && (
                                    <div
                                        className={`${getCls('list-item')}`}
                                        style={{
                                            color: '#FF4343',
                                        }}
                                        onClick={e => {
                                            hidePopover(e)
                                            showLayer(
                                                <DeleteGroup
                                                    name={props.group.name}
                                                    num={props.group.goods_num}
                                                    groupId={props.group.id}
                                                />,
                                            )
                                        }}
                                    >
                                        删除
                                    </div>
                                )}
                            </>
                        }
                    >
                        <i
                            className={`iconfont iconmore2 ${getCls('more')}`}
                            onClick={e => {
                                e.stopPropagation()
                                setPopoverVisable(!popoverVisable)
                            }}
                        />
                    </Popover>
                    <span>{group.goods_num}</span>
                </div>
            </div>
            <div
                className={getCls('item', 'menu')}
                style={{
                    height: group.open && group.secondary_group[0]?.id ? `${group.secondary_group.length * 70}px` : '0',
                }}
            >
                {!!group.secondary_group.length &&
                    group.secondary_group[0].id &&
                    group.secondary_group.map(second => (
                        <DropContent
                            key={second?.id}
                            type={TYPE}
                            onDrop={item => {
                                props.handleDrop(item.goods_ids, group.id || 0, second?.id)
                            }}
                        >
                            <SecondItemGroup second={second} groupId={group.id} />
                        </DropContent>
                    ))}
            </div>
        </>
    )
})

export default GroupItem
